import { FC, useCallback, useContext, useMemo, useRef } from 'react';

import { DropProps } from '@hh.ru/magritte-ui';

import { ResumeCardActionsContext } from 'src/components/ResumeCard/Actions/Context';
import { useFeatureEnabled } from 'src/hooks/useFeatureEnabled';
import { useToggleState } from 'src/hooks/useToggleState';
import { VIEW_WITHOUT_CONTACTS } from 'src/utils/constants/resumePermission';

import Button from 'src/components/ResumeCard/Actions/Additional/Button';
import Menu from 'src/components/ResumeCard/Actions/Additional/Menu';
import MenuResponse from 'src/components/ResumeCard/Actions/Additional/Menu/Response';

const Features = {
    videoCallsDisabled: 'video_calls_disabled',
};

const Additional: FC<{ onShareResume?: () => void }> = ({ onShareResume }) => {
    const { isResponse, isPfpVacancy, resume } = useContext(ResumeCardActionsContext);
    const isHiddenByPfp = isPfpVacancy ? resume._attributes.permission === VIEW_WITHOUT_CONTACTS : false;

    const [isMenuVisible, toggleMenuVisible, setMenuVisible] = useToggleState(false);
    const closeMenu = useCallback(() => setMenuVisible(false), [setMenuVisible]);

    const menuActivatorRef = useRef(null);
    const menuDropProps = useMemo<DropProps>(
        () => ({
            activatorRef: menuActivatorRef,
            role: 'status',
            placement: 'bottom-right',
            maxWidth: 400,
            space: 0,
        }),
        []
    );
    const isVideoCallsDisabled = useFeatureEnabled(Features.videoCallsDisabled);

    const menuProps = { isMenuVisible, closeMenu, menuDropProps, onShareResume, isHiddenByPfp };
    // Скрываем и кнопку и дроп, потому что там только один единственный пункт – видеозвонок.
    if (!isResponse && isVideoCallsDisabled) {
        return null;
    }
    const MenuComponent = isResponse ? MenuResponse : Menu;

    return (
        <>
            <Button menuActivatorRef={menuActivatorRef} toggleMenuVisible={toggleMenuVisible} />
            <MenuComponent {...menuProps} />
        </>
    );
};

export default Additional;
